import { type DependencyList, type EffectCallback, useEffect, useRef } from 'react';

/**
 * Custom React hook similar to useEffect, but runs only on updates deps change and not on mount.
 * @param {EffectCallback} effect - Function that contains the code to be executed on updates.
 * @param {DependencyList} [deps] - An array of dependencies. The effect will re-run if any of these dependencies change.
 */

export const useWatchEffect = (effect: EffectCallback, deps?: DependencyList) => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return effect();
    }

    isMounted.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps is the caller-provided dependency list passed straight through to useEffect; the lint rule cannot verify a pass-through array
  }, deps);
};
